import { LOGIN_STATES, AUTH_ERRORS } from '@/constants/auth'

export interface User {
  permissions: string[]
  user: {
    id: number
    first_name: string
    last_name: string
    full_name: string
  }
}

export interface InactivityModalState {
  modal: boolean
  time: number
}

export interface AuthState {
  loader: boolean | null
  user: User | null
  forcedToLogout: boolean
  isRefreshRequestSent: boolean
  inactivityModalVisible: InactivityModalState
}

export interface LoginCredentials {
  email: string
  password: string
}

export interface AuthenticateTokenResponse {
  token: string
}

export interface AuthenticateMfaResponse {
  status: 'codeSent'
  email: string
}

export type AuthenticateResponse = AuthenticateTokenResponse | AuthenticateMfaResponse

export function isMfaResponse(response: AuthenticateResponse): response is AuthenticateMfaResponse {
  return 'status' in response && response.status === 'codeSent'
}

export interface MfaVerifyPayload {
  code: string
  rememberMe: boolean
}

export interface ValidateResponse {
  data: User
}

export type LogoutResponse = Record<string, never>

export type AuthError = (typeof AUTH_ERRORS)[keyof typeof AUTH_ERRORS] | null

export type LoginState = (typeof LOGIN_STATES)[keyof typeof LOGIN_STATES]
